<mat-button-toggle-group [value]="value" (change)="setValue($event.value)" [disabled]="disabled" appearance="legacy">
  <mat-button-toggle [value]="null" [checked]="value === null">{{ labelUnset }}</mat-button-toggle>
  <mat-button-toggle [value]="true" [checked]="value === true">{{ labelTrue }}</mat-button-toggle>
  <mat-button-toggle [value]="false" [checked]="value === false">{{ labelFalse }}</mat-button-toggle>
</mat-button-toggle-group>
